import React, { useState, useEffect } from 'react';
import { useUploadQueueContext } from '../contexts/UploadQueueContext';

const UploadQueueModal = () => {
  const {
    uploadQueue,
    isModalVisible,
    setIsModalVisible,
    isModalMinimized,
    setIsModalMinimized,
  } = useUploadQueueContext();

  const [currentTime, setCurrentTime] = useState(new Date());

  // Actualizar el tiempo cada segundo para el contador
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  // No mostrar si no hay uploads o el modal está oculto
  if (!isModalVisible || uploadQueue.length === 0) {
    return null;
  }

  // Mostrar solo la solapa minimizada
  if (isModalMinimized) {
    return (
      <div 
        style={{
          position: 'fixed',
          bottom: '50px',
          right: '0px',
          zIndex: 9999,
          cursor: 'pointer'
        }}
        onClick={() => setIsModalMinimized(false)}
      >
        <div 
          className="button is-primary is-small"
          style={{
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
            paddingLeft: '8px',
            paddingRight: '8px'
          }}
        >
          <span className="icon is-small">
            <i className="fa fa-chevron-left"></i>
          </span>
        </div>
      </div>
    );
  }

  const getStatusIcon = (status) => {
    switch (status) {
      case 'pending':
        return <span className="icon has-text-warning"><i className="fa fa-clock-o"></i></span>;
      case 'processing':
        return <span className="icon has-text-info"><i className="fa fa-spinner fa-spin"></i></span>;
      case 'success':
        return <span className="icon has-text-success"><i className="fa fa-check"></i></span>;
      case 'error':
        return <span className="icon has-text-danger"><i className="fa fa-times"></i></span>;
      default:
        return null;
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case 'pending':
        return 'En espera';
      case 'processing':
        return 'Cargando...';
      case 'success':
        return 'Completado';
      case 'error':
        return 'Error';
      default:
        return '';
    }
  };

  const getProgressColor = (status) => {
    switch (status) {
      case 'pending':
        return 'is-warning';
      case 'processing':
        return 'is-info';
      case 'success':
        return 'is-success';
      case 'error':
        return 'is-danger';
      default:
        return '';
    }
  };

  return (
    <div 
      className="card"
      style={{
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        zIndex: 9999,
        width: '400px',
        maxHeight: '80vh',
        overflowY: 'auto',
        boxShadow: '0 8px 16px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.02)'
      }}
    >
        <header className="card-header">
          <p className="card-header-title is-size-6">
            <span className="icon">
              <i className="fa fa-upload"></i>
            </span>
            <span>Cola de Cargas ({uploadQueue.length}/2)</span>
          </p>
          <div className="card-header-icon">
            <button
              className="button is-small is-white"
              onClick={() => setIsModalMinimized(true)}
              title="Minimizar"
            >
              <span className="icon is-small">
                <i className="fa fa-minus"></i>
              </span>
            </button>
            <button
              className="button is-small is-white"
              onClick={() => setIsModalVisible(false)}
              title="Cerrar"
              style={{ marginLeft: '4px' }}
            >
              <span className="icon is-small">
                <i className="fa fa-times"></i>
              </span>
            </button>
          </div>
        </header>

        <div className="card-content" style={{ padding: '1rem' }}>
          {uploadQueue.map((upload, index) => (
            <div key={upload.id} className="box" style={{ marginBottom: '0.75rem', padding: '0.75rem' }}>
              <div className="level is-mobile">
                <div className="level-left">
                  <div className="level-item">
                    {getStatusIcon(upload.status)}
                  </div>
                  <div className="level-item">
                    <div>
                      <p className="is-size-7 has-text-weight-bold">
                        {upload.fileToUpload[0]?.name || 'Archivo'}
                      </p>
                      <p className="is-size-7 has-text-grey">
                        {getStatusText(upload.status)}
                      </p>
                      {upload.fileDescription && (
                        <p className="is-size-7 has-text-grey-light">
                          {upload.fileDescription}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              
              {/* Barra de progreso */}
              <progress 
                className={`progress is-small ${getProgressColor(upload.status)}`}
                value={upload.status === 'success' ? 100 : upload.status === 'processing' ? 50 : 0}
                max="100"
              >
                {upload.status === 'success' ? '100%' : upload.status === 'processing' ? '50%' : '0%'}
              </progress>

              {/* Mostrar error si existe */}
              {upload.status === 'error' && upload.error && (
                <p className="is-size-7 has-text-danger" style={{ marginTop: '0.25rem' }}>
                  {upload.error}
                </p>
              )}

              {/* Tiempo transcurrido para completados */}
              {(upload.status === 'success' || upload.status === 'error') && upload.completedAt && (
                <div className="is-size-7 has-text-grey-light" style={{ marginTop: '0.25rem' }}>
                  <span className="icon is-small">
                    <i className="fa fa-clock-o"></i>
                  </span>
                  <span>Se ocultará en {Math.max(0, 10 - Math.floor((currentTime - new Date(upload.completedAt)) / 1000))}s</span>
                </div>
              )}
            </div>
          ))}

          {uploadQueue.length === 0 && (
            <div className="has-text-centered has-text-grey">
              <span className="icon is-large">
                <i className="fa fa-upload fa-2x"></i>
              </span>
              <p>No hay cargas en proceso</p>
            </div>
          )}
        </div>
    </div>
  );
};

export default UploadQueueModal;